const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量免费资源',
    desc: '收录超过10万部免费漫画与免费动漫全集，涵盖热血、悬疑、恋爱、异世界等全部品类，无论热门大作还是冷门精品，都能在这里免费畅读。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速同步更新',
    desc: '每日同步更新1000+话，日本连载漫画第一时间呈现。下拉式滚动浏览让阅读更流畅，无需翻页等待，沉浸体验每一话精彩剧情。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净阅读体验',
    desc: '打造无广告干扰的沉浸式在线漫画阅读环境，高清画质加载迅速。支持多种阅读模式，让每一位读者都能享受最纯粹的漫画时光。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            平台特色
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            为什么数百万读者选择虫虫动漫
          </p>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
            {features.map((feat) => (
              <div
                key={feat.title}
                className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${feat.icon} text-xl`}></i>
                </div>
                <h3 className="mt-4 font-heading text-lg text-foreground-900">
                  {feat.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {feat.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}